'use client'
import { LineTrashAlt } from '@qr-front/icons/line-trash-alt'
import { useAtom } from 'jotai'
import { atomWithReset } from 'jotai/utils'
import { useFormContext } from 'react-hook-form'

import { useSyncFieldWithAtom } from '@/hooks'

import { InputButton } from '../../InputButton'
import { TVideoButton, TVideoInfoFields } from '../VideoInfoFormModel'
import { ButtonTextField, ButtonUrlField } from './ButtonInputs'

export const videoButtonListAtom = atomWithReset<TVideoButton[]>([])

export const ButtonsSection = () => {
	const { setValue, trigger } = useFormContext<TVideoInfoFields>()

	const [buttonList, setButtonList] = useAtom(videoButtonListAtom)

	useSyncFieldWithAtom({
		atom: videoButtonListAtom,
		setFieldValue: (value) => setValue('buttons', value),
	})

	if (!buttonList.length) {
		return null
	}

	const handleClickRemove = (index: number) => {
		setButtonList((prev) => prev.filter((_, i) => i !== index))
		trigger('buttons')
	}

	return (
		<ul className="flex flex-col gap-2">
			{buttonList.map((_, index) => (
				<li
					key={index}
					className="flex flex-wrap gap-4 rounded-10 bg-light-grey-70 p-4 tablet:flex-nowrap tablet:p-6"
				>
					<ButtonTextField index={index} buttonList={buttonList} />
					<ButtonUrlField index={index} buttonList={buttonList} />
					<InputButton
						icon={<LineTrashAlt className="size-5" />}
						onClick={() => handleClickRemove(index)}
						className="mt-8"
					/>
				</li>
			))}
		</ul>
	)
}
